// plugins/reload-chunk-error.js
export default function () {
  if (process.client) { // Hanya jalankan di sisi client (browser)
    window.addEventListener('error', (event) => {
      // Deteksi error loading chunk
      if (/Loading chunk [\d]+ failed/.test(event.message)) {
        event.preventDefault();
        console.log('Chunk loading failed (version mismatch). Reloading page...');
        window.location.reload(true); // Force reload dari server
      }
    });
  }
}
